import React from 'react';
import SIcon from './SIcon';
import { faEyeSlash } from '@fortawesome/pro-regular-svg-icons';

const Icon = props => <SIcon {...props} icon={faEyeSlash} fa />;

export default Icon;
